export type ReferrerPartnerContext = {
  currentUrl?: string;
  referrerUrl?: string;
  search?: string;
};

export const normalizeUtmSource = (utmSource: string | null | undefined): string | null => {
  if (!utmSource) return null;

  const cleanSource = utmSource
    .toLowerCase()
    .replace(/^(www\.|http:\/\/|https:\/\/)/, '')
    .replace(/\.(com|net|org|io|co\.uk)$/, '');

  const parts = cleanSource.split(/[._-]/);
  return parts[0] || null;
};

export const getUtmSourceName = (search?: string): string | null => {
  const resolvedSearch = search ?? (typeof window !== 'undefined' ? window.location.search : '');

  return normalizeUtmSource(new URLSearchParams(resolvedSearch).get('utm_source'));
};

export const getMarketWatchModReferrer = (search = ''): string | null => {
  if (!search && typeof window !== 'undefined') {
    search = window.location.search;
  }

  const mod = new URLSearchParams(search).get('mod');
  if (mod?.toLowerCase().startsWith('mw_')) return 'marketwatch';

  return null;
};

export const getReferrerSiteName = (referrerUrl = '', currentUrl = ''): string | null => {
  if (!referrerUrl && typeof document !== 'undefined') {
    referrerUrl = document.referrer;
  }
  if (!currentUrl && typeof window !== 'undefined') {
    currentUrl = window.location.href;
  }
  if (!referrerUrl) return null;

  try {
    const referrer = new URL(referrerUrl);
    const currentSite = new URL(currentUrl);

    if (referrer.hostname === currentSite.hostname) return null;

    const hostParts = referrer.hostname.split('.');

    if (hostParts.length > 2) {
      return hostParts[hostParts.length - 2];
    }
    if (hostParts.length === 2) {
      return hostParts[0];
    }
    return null;
  } catch {
    return null;
  }
};

export const getReferrerPartnerName = (context: ReferrerPartnerContext = {}): string | null =>
  getUtmSourceName(context.search) ||
  getMarketWatchModReferrer(context.search) ||
  getReferrerSiteName(context.referrerUrl, context.currentUrl);

export const mergeReferrerPartnerTargeting = (
  targeting?: Record<string, string | string[]>,
  context: ReferrerPartnerContext = {},
): Record<string, string | string[]> => {
  const referrer = getReferrerPartnerName(context);
  if (!referrer) return targeting ?? {};

  return { ...targeting, referrer };
};
